/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomShareTokenFromJSON, StreemApiRoomShareTokenToJSON, } from './';
export function StreemApiCreateRoomShareTokenResponseFromJSON(json) {
    return StreemApiCreateRoomShareTokenResponseFromJSONTyped(json, false);
}
export function StreemApiCreateRoomShareTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shareToken': !exists(json, 'share_token') ? undefined : StreemApiRoomShareTokenFromJSON(json['share_token']),
    };
}
export function StreemApiCreateRoomShareTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'share_token': StreemApiRoomShareTokenToJSON(value.shareToken),
    };
}
//# sourceMappingURL=StreemApiCreateRoomShareTokenResponse.js.map